/**
 * Shared styling for active filter state.
 * Use with UInput/USelectMenu :ui prop when filter has a value.
 */
export const activeFilterUi = {
  base: 'ring-[var(--ui-primary)] bg-[var(--ui-primary)]/10 text-[var(--ui-primary)]',
}

/**
 * Sort options array to put selected values first.
 * @param options - Array of options with a value property
 * @param selected - Array of selected values
 * @param valueKey - Key to use for matching (default: 'value')
 */
export function sortSelectedFirst<T extends Record<string, unknown>>(
  options: T[],
  selected: string[],
  valueKey: keyof T = 'value',
): T[] {
  const selectedSet = new Set(selected)
  return [
    ...options.filter((o) => selectedSet.has(o[valueKey] as string)),
    ...options.filter((o) => !selectedSet.has(o[valueKey] as string)),
  ]
}
